



































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import claimStatusTypeArr from '@/const/words/claimStatusTypes';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import { getOrderStatusTypeName } from '@/utils/formatUtils';
import { ComponentItemsClaimDataType } from '@/views/claim/components/dataType/ComponentDataType';
@Component({
  components: { CompSelectBox },
})
export default class ComponentItemsClaim extends Vue {
  //A
  @Prop({ required: true })
  private pageName!: string;

  @Prop({ default: false })
  private checkboxShow!: boolean;

  @Prop({ default: false })
  private escrowOrder!: boolean;

  @Prop({ required: false })
  private postPredict!: {};

  @Prop({ required: true })
  private orderOptionsApply!: ComponentItemsClaimDataType; //GetClaimsOrderOptionsOrderOptionNoApplyResponse;
  private claimableOptions!: any[];

  @Prop({ default: '' })
  private refundType!: string;

  @Prop({ default: false })
  private modifyClaim!: boolean;

  @Prop({ required: false, default: null })
  private payType: string;

  private selectAll: boolean = false;
  private disabledAllCheck: boolean = false;
  private disabledCheckbox: boolean = false;
  private claimReasonTypeDisabled: boolean = false;
  private orderCntMap: Map<number, number> = new Map();
  private optionno: number[] = [];
  private selectDisable: boolean[] = [];
  private orderCntArry: number[] = [];
  private claimReasonType: string = '';
  private orderOptionParams: any = [];
  private get claimReasonTypeList() {
    let list: any = [
      {
        value: 'CHANGE_MIND',
        name: this.$t('CLAIM_CANCELPOPUP_CHANGE_MIND'),
      },
      {
        value: 'DEFECTIVE_PRODUCT',
        name: this.$t('CLAIM_CANCELPOPUP_DEFECTIVE_PRODUCT'),
      },
      {
        value: 'WRONG_DELIVERY',
        name: this.$t('CLAIM_CANCELPOPUP_WRONG_DELIVERY'),
      },
      {
        value: 'WRONG_PRODUCT_DETAIL',
        name: this.$t('CLAIM_CANCELPOPUP_WRONG_PRODUCT_DETAIL'),
      },
      {
        value: 'DELAY_DELIVERY',
        name: this.$t('CLAIM_CANCELPOPUP_DELAY_DELIVERY'),
      },
      {
        value: 'OUT_OF_STOCK',
        name: this.$t('CLAIM_CANCELPOPUP_OUT_OF_STOCK'),
      },
    ];

    if (this.payType !== 'NAVER_PAY') {
      list = [
        ...list,
        {
          value: 'OTHERS_SELLER',
          name: this.$t('CLAIM_CANCELPOPUP_OTHERS_SELLER'),
        },
        {
          value: 'OTHERS_BUYER',
          name: this.$t('CLAIM_CANCELPOPUP_OTHERS_BUYER'),
        },
      ];
    }

    return list;
  }

  private sellerFaultReasons: string[] = [
    'DEFECTIVE_PRODUCT',
    'WRONG_DELIVERY',
    'OUT_OF_STOCK_SYSTEM',
    'WRONG_PRODUCT_DETAIL',
    'DELAY_DELIVERY',
    'OTHERS_SELLER',
    'OUT_OF_STOCK',
  ];
  private responsibleObjectTypeText: string = '';
  private claimReasonDetail: string = '';
  private rowspanNum: number = 0;
  private rowSpanpartnerNoMap: Map<number, { isRowSpan: boolean; rowSpans: number }> = new Map();
  private rowSpanMallProductNoMap: Map<number, { isRowSpan: boolean; rowSpans: number }> = new Map();
  private responsibleObjectTypeValue = '';

  @Watch('refundType')
  onRefundTypeChanged() {
    if (this.pageName == 'ReturnPopup') {
      if (this.escrowOrder) {
        this.disabledAllCheck = true;
        this.selectAll = true;
        this.disabledCheckbox = true;

        if (this.refundType == 'KCP') {
          this.claimReasonTypeDisabled = true;
        } else if (this.refundType == 'CASH') {
          this.claimReasonTypeDisabled = false;
        } else {
          this.claimReasonTypeDisabled = false;
        }
      }
    }
  }

  private created() {
    this.claimCalculation();
  }

  private showOrderStatusTypeName(code: string) {
    return getOrderStatusTypeName(code);
  }

  private getClaimReason(code: string) {
    let list: any[] = this.claimReasonTypeList;
    return (list.find(key => key.value === code) as any).name;
  }

  private showClaimStatusType(value: string) {
    let returnValue: string = (claimStatusTypeArr.find(key => key.value === value) as any).name;
    return returnValue.replace('[', '<br>[');
  }

  private getType() {
    if (
      this.pageName === 'CancelPopup' ||
      this.pageName === 'CancelAllPopup' ||
      this.pageName === 'ExchangePopupBefore'
    ) {
      return this.$t('CLAIM_EXCHANGEPOPUP_CANCEL');
    }

    if (this.pageName === 'ReturnPopup' || this.pageName === 'ExchangePopupAfter') {
      return this.$t('CLAIM_EXCHANGEPOPUP_RETURN');
    }
  }

  private orderCntChange(orderOptionNo: number, index: number, orderCnt: number, isQuantityDiscount: boolean) {
    if (isQuantityDiscount) {
      this.orderCntArry[index] = orderCnt;
    }

    if (this.orderCntArry[index] < 1) {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_CLAIM_CNT_MINIMUM_MESSAGE', { type: this.getType() }));
      this.orderCntArry[index] = 1;
      this.$refs.claimCntInputRef[0].value = 1; // v-model이 배열로 되어있어 반영이 안됨 그래서 ref로 직접변경
    }

    if (this.orderCntArry[index] > orderCnt) {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_CLAIM_CNT_MAXIMUM_MESSAGE', { type: this.getType(), num: orderCnt }));
      this.orderCntArry[index] = orderCnt;
      this.$refs.claimCntInputRef[0].value = orderCnt;
    }

    this.orderCntMap.set(orderOptionNo, this.orderCntArry[index]);
    for (let i = 0; i < this.optionno.length; i++) {
      let claimCnt = this.orderCntMap.get(this.optionno[i]) || 0;
      this.orderOptionParams[i] = {
        claimCnt: claimCnt,
        orderOptionNo: this.optionno[i],
      };
    }

    this.claimableOptions.forEach((item: any, index: number) => {
      item.totalProductPrice = item.salePrice + item.addPrice - item.immediateDiscountAmt;
      this.claimableOptions[index].totalProductPrice = item.totalProductPrice;
      this.claimableOptions[index].totalProductPriceOrderCnt = item.totalProductPrice * this.orderCntArry[index];
      this.$forceUpdate(); // 배열에 데이터를 담아 쓰는 형태라 업데이트 되는 타이밍이 한박자 느림. cnt가 바뀔때마다 forceUpdate
    });

    if (this.pageName === 'CancelPopup' || this.pageName === 'CancelAllPopup') {
      this.$emit('setData', 'postPredict');
    } else {
      this.$emit('setData');
    }
  }

  private claimReasonTypeChange() {
    this.$nextTick(() => {
      this.responsibleObjectTypeValue = this.sellerFaultReasons.indexOf(this.claimReasonType) >= 0 ? 'SELLER' : 'BUYER';
      (this.$parent.$refs.componentProductDetails as any).chargeDeliveryAmt =
        this.responsibleObjectTypeValue === 'SELLER';

      if (this.pageName === 'ReturnPopup') {
        if (this.responsibleObjectTypeValue === 'SELLER') {
          (this.$parent.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustAmtDisabled = true;
          (this.$parent.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustReasonDisabled = true;
        } else {
          (this.$parent.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustAmtDisabled = false;
          (this.$parent.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustReasonDisabled = false;
        }
      }
      if (this.pageName === 'CancelPopup' || this.pageName === 'CancelAllPopup') {
        this.$emit('setData', 'postPredict');
      } else {
        this.$emit('setData');
      }
    });
  }

  private get checkAll(): boolean {
    if (this.optionno.length === 0) {
      return false;
    }

    return this.claimableOptions.length === this.optionno.length;
  }
  private set checkAll(checked: boolean) {
    let selected = [];
    if (checked) {
      selected = this.claimableOptions.map(claimableOption => claimableOption.orderOptionNo);
    }

    this.optionno = [...selected];
    this.orderOptionParams = this.optionno.map((optionNo, index) => {
      const claimCnt = this.orderCntMap.get(this.optionno[index]) || 0;
      return {
        claimCnt: claimCnt,
        orderOptionNo: this.optionno[index],
      };
    });

    if (checked) {
      if (this.pageName === 'CancelPopup' || this.pageName === 'CancelAllPopup') {
        this.$emit('setData', 'postPredict');
      } else {
        this.$emit('setData');
      }
    } else {
      this.$emit('defaultPredict');
    }
  }

  private onChangeCheckBoxes(e: Event, i: number, orderProductOptionNo: number) {
    let orderOptionParams: any = [];
    this.orderCntMap.set(orderProductOptionNo, this.orderCntArry[i]);
    if (this.optionno.length === 0) {
      const type =
        this.pageName === 'CancelPopup' || this.pageName === 'CancelAllPopup' || this.pageName === 'ExchangePopupbefore'
          ? this.$t('CLAIM_COMMON_CANCEL')
          : this.$t('CLAIM_COMMON_RETURN');
      alert(this.$t('CLAIM_CANCELPOPUP_SELECT_ONE', { type }));
      this.optionno = [...this.optionno, orderProductOptionNo];
      this.$nextTick(() => {
        $(e.target).prop('checked', true);
      });
    } else {
      for (let i = 0; i < this.optionno.length; i++) {
        let claimCnt = this.orderCntMap.get(this.optionno[i]) || 0;
        orderOptionParams[i] = {
          claimCnt: claimCnt,
          orderOptionNo: this.optionno[i],
        };
      }
      this.selectDisable[i] = this.optionno.indexOf(orderProductOptionNo) < 0;
      this.orderOptionParams = orderOptionParams;
      if (this.pageName === 'CancelPopup' || this.pageName === 'CancelAllPopup') {
				console.log('setData postPredict');
        this.$emit('setData', 'postPredict');
      } else {
				console.log('setData');
        this.$emit('setData');
      }
    }
  }
  private showOption(optionName: string, optionValue: string) {
    let opName: string[] = optionName.split('|');
    let opValue: string[] = optionValue.split('|');
    let returnValue = '';
    for (let i = 0; i < opName.length; i++) {
      returnValue = returnValue + opName[i] + ':' + opValue[i] + ' | ';
    }

    return returnValue.substring(0, returnValue.length - 3);
  }

  private onClickModifyClaim() {
    this.$emit('onClickModifyClaim');
  }

  private claimCalculation() {
    this.claimableOptions = this.orderOptionsApply.claimableOptions;
    let partnerNo = -1;
    let mallProductNo = '';
    this.claimableOptions.forEach((item: any, index: number) => {
      item.totalProductPrice = item.salePrice + item.addPrice - item.immediateDiscountAmt;
      this.claimableOptions[index].totalProductPrice = item.totalProductPrice;
      this.claimableOptions[index].totalProductPriceOrderCnt = item.totalProductPrice * item.orderCnt;

      switch (this.pageName) {
        case 'CancelAllPopup':
          this.optionno.push(item.orderOptionNo);
          this.orderOptionParams.push({
            claimCnt: item.claimedCnt,
            orderOptionNo: item.orderOptionNo,
          });
          if (index > 0) {
            this.rowspanNum++;
          }
          if (partnerNo == item.partnerNo) {
            this.rowSpanpartnerNoMap.set(index, { isRowSpan: false, rowSpans: 1 });
          } else {
            this.rowSpanpartnerNoMap.set(index, {
              isRowSpan: true,
              rowSpans: this.claimableOptions.filter(e => {
                return e.partnerNo == item.partnerNo;
              }).length,
            });
          }
          if (mallProductNo == item.mallProductNo) {
            this.rowSpanMallProductNoMap.set(index, { isRowSpan: false, rowSpans: 1 });
          } else {
            this.rowSpanMallProductNoMap.set(index, {
              isRowSpan: true,
              rowSpans: this.claimableOptions.filter(e => {
                return e.mallProductNo == item.mallProductNo;
              }).length,
            });
          }
          partnerNo = item.partnerNo;
          mallProductNo = item.mallProductNo;
          this.orderCntMap.set(item.orderOptionNo, item.orderCnt);
          this.orderCntArry[index] = item.orderCnt;
          this.responsibleObjectTypeText = this.$t('CLAIM_CANCELPOPUP_BUYER').toString();
          break;

        case 'CancelPopup':
          if (item.checkboxValue) {
            this.optionno.push(item.orderOptionNo);
            this.selectDisable[index] = false;
            this.orderOptionParams.push({
              claimCnt: item.claimedCnt,
              orderOptionNo: item.orderOptionNo,
            });
          } else {
            this.selectDisable[index] = true;
            this.rowspanNum++;
          }
          this.rowSpanpartnerNoMap.set(index, { isRowSpan: true, rowSpans: 1 });
          this.rowSpanMallProductNoMap.set(index, { isRowSpan: true, rowSpans: 1 });
          partnerNo = item.partnerNo;
          mallProductNo = item.mallProductNo;
          this.orderCntMap.set(item.orderOptionNo, item.orderCnt);
          this.orderCntArry[index] = item.orderCnt;
          this.responsibleObjectTypeText = this.$t('CLAIM_CANCELPOPUP_BUYER').toString();
          break;

        case 'ReturnPopup':
          if (this.escrowOrder) {
            item.checkboxValue = true;
            this.rowspanNum++;
          }
          if (item.checkboxValue) {
            this.optionno.push(item.orderOptionNo);
            this.selectDisable[index] = false;
            this.orderOptionParams.push({
              claimCnt: item.claimedCnt,
              orderOptionNo: item.orderOptionNo,
            });
          } else {
            this.selectDisable[index] = true;
            this.rowspanNum++;
          }
          this.rowSpanpartnerNoMap.set(index, { isRowSpan: true, rowSpans: 1 });
          this.rowSpanMallProductNoMap.set(index, { isRowSpan: true, rowSpans: 1 });
          partnerNo = item.partnerNo;
          mallProductNo = item.mallProductNo;
          this.orderCntMap.set(item.orderOptionNo, item.orderCnt);
          this.orderCntArry[index] = item.orderCnt;
          this.responsibleObjectTypeText = this.$t('CLAIM_CANCELPOPUP_BUYER').toString();
          if (this.escrowOrder) {
            this.selectDisable[index] = true;
            this.disabledAllCheck = true;
            this.selectAll = true;
            this.disabledCheckbox = true;
            this.claimReasonTypeDisabled = true;
          }
          if (this.claimableOptions.length == 1) {
            this.disabledAllCheck = true;
            this.disabledCheckbox = true;
            this.selectAll = true;
          }
          break;

        case 'ExchangePopupBefore':
          this.optionno.push(item.orderOptionNo);
          this.orderOptionParams.push({
            claimCnt: item.claimedCnt,
            orderOptionNo: item.orderOptionNo,
          });
          if (index > 0) {
            this.rowspanNum++;
          }
          this.rowSpanpartnerNoMap.set(index, { isRowSpan: true, rowSpans: 1 });
          this.rowSpanMallProductNoMap.set(index, { isRowSpan: true, rowSpans: 1 });
          partnerNo = item.partnerNo;
          mallProductNo = item.mallProductNo;
          this.orderCntMap.set(item.orderOptionNo, item.orderCnt);
          this.orderCntArry[index] = item.orderCnt;
          this.responsibleObjectTypeText = this.$t('CLAIM_CANCELPOPUP_BUYER').toString();
          break;

        case 'ExchangePopupAfter':
          this.rowSpanpartnerNoMap.set(index, { isRowSpan: true, rowSpans: 1 });
          this.rowSpanMallProductNoMap.set(index, { isRowSpan: true, rowSpans: 1 });
          partnerNo = item.partnerNo;
          mallProductNo = item.mallProductNo;
          this.orderCntMap.set(item.orderOptionNo, item.orderCnt);
          this.orderCntArry[index] = item.orderCnt;
          this.responsibleObjectTypeText = this.$t('CLAIM_CANCELPOPUP_BUYER').toString();
          break;
      }
    });
    if (this.escrowOrder) {
      this.claimReasonType = 'OTHERS_SELLER';
      this.responsibleObjectTypeValue = 'SELLER';
      this.responsibleObjectTypeText = this.$t('CLAIM_CANCELPOPUP_SELLER').toString();
    } else {
      this.claimReasonType = 'CHANGE_MIND';
      this.responsibleObjectTypeValue = 'BUYER';
    }
  }

  private mounted() {
    if (this.pageName !== 'ReturnPopup') {
      this.$emit('setData');
    }
  }
}
